import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import LinkedChartItem from "./LinkedChartItem";
import * as url from "../../utils/url";
import { Container, Row, Col } from "reactstrap";
import noLinkedChart from "../../assets/onboarding/analytics.png";

class LinkedCharts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      charts: [],
    };
  }

  getAttachedItems = () => {
    let { linkedCharts, taskId } = this.props;
    let link_ids = linkedCharts.map(e => e.itemId);
    let payload = {
      linkedCharts: link_ids,
      taskId,
      category: "All",
    };

    if (linkedCharts && linkedCharts.length > 0) {
      // axios.post(url.fetchAttachedCharts, payload ).then( ({ data }) => {
      // let result = data.data
      // let mod = linkedCharts.map(e=> {
      //   console.log(e.chartData)
      //   return { attachedDate: e.date, ...e.chartData}
      // })
      // this.setState({charts:[...mod]})
      // })
    }

    if (linkedCharts && linkedCharts.length > 0) {
      axios.post(url.fetchAttachedCharts, payload).then(({ data }) => {
        let result = data.data;
        let mod = result.map(e => {
          let other = linkedCharts.find(el => el.itemId == e._id);

          console.log(JSON.stringify(e) === JSON.stringify(other.chartData));
          return { attachedDate: other.date, ...e };
        });
        this.setState({ charts: [...mod] });
      });
    }
  };

  componentDidMount() {
    this.getAttachedItems();
  }

  componentDidUpdate(prevProps, prevState) {
    let current_ch = JSON.stringify(prevProps.linkedCharts);
    let prev_ch = JSON.stringify(this.props.linkedCharts);
    if (current_ch != prev_ch) {
      this.getAttachedItems();
    }
  }

  renderView = () => {
    let { charts } = this.state;
    if (charts && charts.length > 0) {
      return (
        <div className="">
          <Row>
            {charts.map((e, idx) => {
              return (
                <div
                  className={`col-md-6 linkedItemContainer`}
                  key={e._id + idx}
                >
                  <LinkedChartItem chart={e} />
                </div>
              );
            })}
          </Row>
        </div>
      );
    } else {
      return <img src={noLinkedChart} className="taskNoLinkedCharts" />;
    }
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(LinkedCharts, axios)));
